import { CellClickedEvent } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';
import {
  ExternalFilterProps,
  SelectionsProps,
  SingleClickEditProps,
  startEditing,
} from 'components/atoms/grid/plugins';

export const useFilter = (
  filter: ExternalFilterProps['filter'],
  provisionalRow?: Record<string, unknown>,
) =>
  useMemo(
    () =>
      filter == null
        ? undefined
        : (record: Record<string, unknown>) =>
            provisionalRow === record || filter(record),
    [filter, provisionalRow],
  );

export const useIsSelectable = (
  isSelectable: SelectionsProps['isSelectable'],
) =>
  useMemo(
    () => (id: string) => id !== 'provisional' && (isSelectable?.(id) ?? true),
    [isSelectable],
  );

export const useOnCellClicked = (
  onCellClicked: SingleClickEditProps['onCellClick'],
) =>
  useCallback(
    (event: CellClickedEvent) => {
      const handled = onCellClicked?.(event) ?? false;

      if (handled) {
        return true;
      }
      const {
        api,
        node: { id },
        rowIndex,
        columnApi,
      } = event;

      if (id !== 'provisional') {
        return false;
      }
      startEditing({ api, rowIndex, column: columnApi.getColumn('status') });

      return true;
    },
    [onCellClicked],
  );
